import React from "react";
import { Col, Container, Row } from "react-bootstrap";

const Footer = () => {
  const today = new Date();
  const year = today.getFullYear();
  return (
    <footer className="text-center" style={{"marginBottom": "40px"}}>
      <Container>
          <hr />
        <Row>
          <Col sm={6} md={4}>
            <h5>
              Arshad's Photography <br /> copyright @ {year}
            </h5>
            <a className="text-decoration-none text-dark" href="!#">
              <strong>About Me</strong>
            </a>
            <br />
            <a className="text-decoration-none text-dark" href="!#">
               <strong>Advertise</strong>
            </a>
            <br />
            <a className="text-decoration-none text-dark" href="!#">
              <strong>Terms & Conditions </strong>
            </a>
            <br />
            <a className="text-decoration-none text-dark" href="!#">
              <strong>Brand Safety</strong>
            </a>
            <br />
            <a className="text-decoration-none text-dark" href="!#">
              <strong>Contact Us</strong>
            </a>
            <br />
            <a className="text-decoration-none text-dark" href="!#">
              <strong>Submit a Wedding</strong>
            </a>
            <br />
            <a className="text-decoration-none text-dark" href="!#">
              <strong>Our Policies</strong>
            </a>
            <br />
            <a className="text-decoration-none text-dark" href="!#">
              <strong>Privacy Policy</strong>
            </a>
          </Col>
          <Col sm={6} md={4}>
            <a className="text-decoration-none text-dark" href="!#">
              <strong>ARTICLES</strong>
            </a>
            <br />
            <a className="text-decoration-none text-dark" href="!#">
              <strong>Real Weddings</strong>
            </a>
            <br />
            <a className="text-decoration-none text-dark" href="!#">
              <strong>Wedding Dresses</strong>
            </a>
            <br />
            <a className="text-decoration-none text-dark" href="!#">
              <strong>Honeymoons & Travel</strong>
            </a>
            <br />
            <a className="text-decoration-none text-dark" href="!#">
              <strong>Wedding Planning</strong>
            </a>
            <br />
            <a className="text-decoration-none text-dark" href="!#">
              <strong>Hen Parties</strong>
            </a>
          </Col>
          <Col sm={6} md={4}>
            <a className="text-decoration-none text-dark" href="!#">
              <strong>CONTACT</strong>
            </a>
            <br />
            <a className="text-decoration-none text-dark" href="!#">
              <strong>Phone: +8801717885599</strong>
            </a>
            <br />
            <a className="text-decoration-none text-dark" href="!#">
              <strong>Email: hello@arshad.com</strong>
            </a>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default Footer;
